import colorflow from './colorflow.js'
function toHex(stringInt) {
    var integerVal = parseInt(stringInt)
    if (integerVal > 255) {
        integerVal = 255
    } else if (integerVal < 0) {
        integerVal = 0
    }
    return integerVal.toString(16).padStart(2, '0')
}

export default {
    darken(color, percent) {
        var hex = this.getHexColor(color)
        var hsl = colorflow.hex2hsl(hex)
        var newLight = hsl[2] * ((100 - percent) / 100)
        // debugger
        hsl[2] = newLight < 0 ? 0 : newLight
        return colorflow.hsl2hex(hsl)
    },
    lighten(color, percent) {
        var hex = this.getHexColor(color)
        var hsl = colorflow.hex2hsl(hex)
        var newLight = hsl[2] * ((100 + percent) / 100)
        // debugger
        hsl[2] = newLight > 1 ? 1 : newLight
        return colorflow.hsl2hex(hsl)
    },
    getHexColor(color) {
        if (/^#/.test(color)) {
            return color
        }

        if (color.startsWith('rgb')) {
            // do nothing, regex will match
        } else if (this.isColor(color)) {
            color = this.getCssColor(color)
        } else {
            color = this.getStandardColor(color)

            if (!color) {
                throw 'Invalid color string'
            }
            // already a hex value
            return color
        }

        var groups = color.match(/(\d+),\s*(\d+),\s*(\d+)/)
        var r = toHex(groups[1])
        var g = toHex(groups[2])
        var b = toHex(groups[3])

        return `#${r}${g}${b}`
    },
    getHexColor(color) {
        if (/^#/.test(color)) {
            return color
        }

        if (color.startsWith('rgb')) {
            // do nothing, regex will match
        } else if (this.isColor(color)) {
            color = this.getCssColor(color)
        } else {
            color = this.getColor(color)
        }

        if (!color) {
            throw 'Invalid color string'
        }

        var groups = color.match(/(\d+),(\d+),(\d+)/)
        var r = toHex(groups[1])
        var g = toHex(groups[2])
        var b = toHex(groups[3])

        return `#${r}${g}${b}`
    },
    getColorString(colorx, alphax = 1) {
        if (this.isColor(colorx)) {
            return `rgba(var(--vs-${colorx}), ${alphax})`
        }

        var standardColor = this.getStandardColor(colorx)
        return this.getColor(standardColor || colorx, alphax)
    },
    getColor(colorx, alphax = 1, defaultx = true) {
        if (/^[#]/.test(colorx)) {
            // change color hex to RGB
            let c = this.hexToRgb(colorx)

            if (alphax == 1) {
                colorx = `rgb(${c.r},${c.g},${c.b})`
            } else {
                colorx = `rgba(${c.r},${c.g},${c.b},${alphax})`
            }
        } else if (/^rgba/.test(colorx)) {
            if (colorx.search(/.([0-9]\))$/) == -1 && !defaultx) {
                colorx = colorx.replace(/.?([0-9]\))$/, `${alphax})`)
            }
        } else if (/^(rgb)/.test(colorx)) {
            // change rgb and rgba
            if (alphax != 1) {
                colorx = colorx.replace(/^(rgb)/, `rgba`)
                colorx = colorx.replace(/\)$/, `,${alphax})`)
            }
        }
        return colorx
    },
    isColor(colorx) {
        const vsColors = [
            'primary',
            'secondary',
            'success',
            'danger',
            'warning',
            'dark',
            'gold',
            'lead',
            'opportunity',
            'quote',
            'order',
            'invoice'
        ]
        return vsColors.includes(colorx)
    },
    random() {
        function getRandomInt(min, max) {
            return Math.floor(Math.random() * (max - min)) + min
        }
        return `rgb(${getRandomInt(0, 255)},${getRandomInt(0, 255)},${getRandomInt(0, 255)})`
    },
    setCssVariable(propertyName, value) {
        if (typeof window !== 'undefined') {
            document.documentElement.style.setProperty(propertyName, value)
        }
    },
    getCssColor(color) {
        if (typeof window !== 'undefined') {
            return getComputedStyle(document.documentElement).getPropertyValue(`--vs-${color}`)
        }
    },
    hexToRgb(hex) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b
        })

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
        return result
            ? {
                  r: parseInt(result[1], 16),
                  g: parseInt(result[2], 16),
                  b: parseInt(result[3], 16)
              }
            : null
    },
    getComplement(color) {
        var colorHex = this.getHexColor(color)
        return colorflow.complement(colorHex)
    },
    getAnalogousSet(color, count) {
        var shadeCount = count || 5
        var colorHex = this.getHexColor(color)
        var hsl = colorflow.hex2hsl(colorHex)
        var result = [colorHex]

        for (var i = 1; i < shadeCount; i++) {
            var multiplier = Math.ceil(i / 2)

            if (i % 2 == 0) {
                multiplier = multiplier * -1
            }
            var newHue = hsl[0] + (30 / 360) * multiplier
            var newHsl = [newHue, hsl[1], hsl[2]]
            result.push(colorflow.hsl2hex(newHsl))
        }

        return result
    },
    getComplementarySet(color) {
        var colorHex = this.getHexColor(color)
        return [colorHex, this.getComplement(colorHex)]
    },
    getTriadicSet(color) {
        var colorHex = this.getHexColor(color)
        return colorflow.triadic(colorHex)
    },
    getTetradicSet(color) {
        var colorHex = this.getHexColor(color)
        return colorflow.tetradic(colorHex)
    },
    getPentadicSet(color) {
        var colorHex = this.getHexColor(color)
        return colorflow.pentadic(colorHex)
    },
    getMonochromaticSet(color, count) {
        var shadeCount = count || 20
        var colorHex = this.getHexColor(color)
        var hsl = colorflow.hex2hsl(colorHex)
        var shadeStep = 1.0 / shadeCount
        var result = [colorHex]

        for (var i = 1; i < shadeCount; i++) {
            var light = i * shadeStep + hsl[2]
            light = light > 1 ? light - 1 : light
            var newHsl = [hsl[0], hsl[1], light]
            result.push(colorflow.hsl2hex(newHsl))
        }

        return result
    },
    getVariable(styles, propertyName) {
        return String(styles.getPropertyValue(propertyName)).trim()
    },
    changeColor(colorInicial) {
        let colorx

        if (this.isColor(colorInicial)) {
            let style = getComputedStyle(document.documentElement)
            colorx = this.getVariable(style, '--' + colorInicial)
        } else {
            if (/[rgb()]/g.test(colorInicial)) {
                colorx = colorInicial.replace(/[rgb()]/g, '')
            } else if (/[#]/g.test(colorInicial)) {
                let rgbx = this.hexToRgb(colorInicial)
                colorx = `${rgbx.r},${rgbx.g},${rgbx.b}`
            } else {
                colorx = '--' + colorInicial
            }
        }
        return colorx
        // this.setCssVariable('--'+clave,colorx)
    },
    getStandardColor(color) {
        const colors = {
            'aliceblue': '#f0f8ff',
            'antiquewhite': '#faebd7',
            'aqua': '#00ffff',
            'aquamarine': '#7fffd4',
            'azure': '#f0ffff',
            'beige': '#f5f5dc',
            'bisque': '#ffe4c4',
            'black': '#000000',
            'blanchedalmond': '#ffebcd',
            'blue': '#0000ff',
            'blueviolet': '#8a2be2',
            'brown': '#a52a2a',
            'burlywood': '#deb887',
            'cadetblue': '#5f9ea0',
            'chartreuse': '#7fff00',
            'chocolate': '#d2691e',
            'coral': '#ff7f50',
            'cornflowerblue': '#6495ed',
            'cornsilk': '#fff8dc',
            'crimson': '#dc143c',
            'cyan': '#00ffff',
            'darkblue': '#00008b',
            'darkcyan': '#008b8b',
            'darkgoldenrod': '#b8860b',
            'darkgray': '#a9a9a9',
            'darkgreen': '#006400',
            'darkkhaki': '#bdb76b',
            'darkmagenta': '#8b008b',
            'darkolivegreen': '#556b2f',
            'darkorange': '#ff8c00',
            'darkorchid': '#9932cc',
            'darkred': '#8b0000',
            'darksalmon': '#e9967a',
            'darkseagreen': '#8fbc8f',
            'darkslateblue': '#483d8b',
            'darkslategray': '#2f4f4f',
            'darkturquoise': '#00ced1',
            'darkviolet': '#9400d3',
            'deeppink': '#ff1493',
            'deepskyblue': '#00bfff',
            'dimgray': '#696969',
            'dodgerblue': '#1e90ff',
            'firebrick': '#b22222',
            'floralwhite': '#fffaf0',
            'forestgreen': '#228b22',
            'fuchsia': '#ff00ff',
            'gainsboro': '#dcdcdc',
            'ghostwhite': '#f8f8ff',
            'gold': '#ffd700',
            'goldenrod': '#daa520',
            'gray': '#808080',
            'green': '#008000',
            'greenyellow': '#adff2f',
            'honeydew': '#f0fff0',
            'hotpink': '#ff69b4',
            'indianred ': '#cd5c5c',
            'indigo': '#4b0082',
            'ivory': '#fffff0',
            'khaki': '#f0e68c',
            'lavender': '#e6e6fa',
            'lavenderblush': '#fff0f5',
            'lawngreen': '#7cfc00',
            'lemonchiffon': '#fffacd',
            'lightblue': '#add8e6',
            'lightcoral': '#f08080',
            'lightcyan': '#e0ffff',
            'lightgoldenrodyellow': '#fafad2',
            'lightgrey': '#d3d3d3',
            'lightgreen': '#90ee90',
            'lightpink': '#ffb6c1',
            'lightsalmon': '#ffa07a',
            'lightseagreen': '#20b2aa',
            'lightskyblue': '#87cefa',
            'lightslategray': '#778899',
            'lightsteelblue': '#b0c4de',
            'lightyellow': '#ffffe0',
            'lime': '#00ff00',
            'limegreen': '#32cd32',
            'linen': '#faf0e6',
            'magenta': '#ff00ff',
            'maroon': '#800000',
            'mediumaquamarine': '#66cdaa',
            'mediumblue': '#0000cd',
            'mediumorchid': '#ba55d3',
            'mediumpurple': '#9370d8',
            'mediumseagreen': '#3cb371',
            'mediumslateblue': '#7b68ee',
            'mediumspringgreen': '#00fa9a',
            'mediumturquoise': '#48d1cc',
            'mediumvioletred': '#c71585',
            'midnightblue': '#191970',
            'mintcream': '#f5fffa',
            'mistyrose': '#ffe4e1',
            'moccasin': '#ffe4b5',
            'navajowhite': '#ffdead',
            'navy': '#000080',
            'oldlace': '#fdf5e6',
            'olive': '#808000',
            'olivedrab': '#6b8e23',
            'orange': '#ffa500',
            'orangered': '#ff4500',
            'orchid': '#da70d6',
            'palegoldenrod': '#eee8aa',
            'palegreen': '#98fb98',
            'paleturquoise': '#afeeee',
            'palevioletred': '#d87093',
            'papayawhip': '#ffefd5',
            'peachpuff': '#ffdab9',
            'peru': '#cd853f',
            'pink': '#ffc0cb',
            'plum': '#dda0dd',
            'powderblue': '#b0e0e6',
            'purple': '#800080',
            'rebeccapurple': '#663399',
            'red': '#ff0000',
            'rosybrown': '#bc8f8f',
            'royalblue': '#4169e1',
            'saddlebrown': '#8b4513',
            'salmon': '#fa8072',
            'sandybrown': '#f4a460',
            'seagreen': '#2e8b57',
            'seashell': '#fff5ee',
            'sienna': '#a0522d',
            'silver': '#c0c0c0',
            'skyblue': '#87ceeb',
            'slateblue': '#6a5acd',
            'slategray': '#708090',
            'snow': '#fffafa',
            'springgreen': '#00ff7f',
            'steelblue': '#4682b4',
            'tan': '#d2b48c',
            'teal': '#008080',
            'thistle': '#d8bfd8',
            'tomato': '#ff6347',
            'turquoise': '#40e0d0',
            'violet': '#ee82ee',
            'wheat': '#f5deb3',
            'white': '#ffffff',
            'whitesmoke': '#f5f5f5',
            'yellow': '#ffff00',
            'yellowgreen': '#9acd32'
        }

        return colors[color.toLowerCase()] || false
    }
}
